import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [{ path: "me/style", lazy: page(() => import("./StylePage")), handle: shows("cosmetics") }],
};
